export default "__VITE_ASSET__CCuZzNAw__"